import script from "./CooperationPartnerAccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CooperationPartnerAccordionItem.vue?vue&type=script&setup=true&lang=js"

import "./CooperationPartnerAccordionItem.vue?vue&type=style&index=0&id=5f05e9f1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f05e9f1"]])

export default __exports__